import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CommunityProgramsPage from "@/pages/admin/CommunityProgramsPage";

export const Route = createFileRoute("/_admin/admin/community-programs")({
  head: () => pageHead("Admin · Community Programs", "AKIVA admin · community programs portal.", "/admin/community-programs", true),
  component: CommunityProgramsPage,
});
